<template>
  <div class="prospects">
    <Layout>
      <template slot="title">
        <sm-heading size="2">Estado de solicitudes</sm-heading>
      </template>

      <div class="prospects__row prospects__row--flex-column" v-show="alreadyusersFirstLoad.status && alreadyusersFirstLoad.length">
        <div class="prospects__row__button-container">
          <sm-button
            label="Filtrar por fecha de selección"
            size="medium"
            icon-right="caret-down"
            class="prospects__row__button-container__top-filter"
            @click="toggleTopFilter"
          />
        </div>
        <div class="prospects__row__top-filter" v-show="topFilter.show && batches.length">
          <div class="prospects__row__top-filter--to-left">
            <sm-checkbox
              v-model="topFilter.general"
              size="small"
              @click="generalBatches"
            >
              General
            </sm-checkbox>
            <sm-checkbox
              v-for="batch in batches"
              :key="batch.idLocal"
              v-model="batch.isConsidered"
              size="small"
            >
              Fecha {{ batch.createdAt }}
            </sm-checkbox>
          </div>
        </div>
      </div>

      <div class="prospects__row prospects__row--center">
        <div class="prospects__row__box prospects__white-row">
          <div class="prospects__row__box__content">
            <p class="prospects__row__box__content__title">Interés de usuarios contactados</p>
            <div class="prospects__row__box__content__text">
              <p class="prospects__row__box__content__text__before">Se han interesado</p>
              <p class="prospects__row__box__content__text__after">{{ alreadyUsers.length }} de {{ totalsProspects }} usuarios</p>
            </div>
            <div class="prospects__row__box__content__text">
              <p class="prospects__row__box__content__text__before">Esperando respuesta de</p>
              <p class="prospects__row__box__content__text__after--minor">{{ waitingResponseUsers }} usuarios</p>
            </div>
          </div>
          <div class="prospects__row__box__circle">
            <vue-easy-pie-chart
              :bar-color="'#00b19d'"
              :font-size="'15px'"
              :track-color="'#f2f2f2'"
              :scale-color="''"
              :percent="alreadyUsers.length && totalsProspects ? Math.round(alreadyUsers.length * 1000 / totalsProspects) / 10 : 0"
              :size="70"
              :line-cap="'round'"
              :line-width="4"
            >
            </vue-easy-pie-chart>
          </div>
        </div>

        <div class="prospects__row__box prospects__white-row">
          <div class="prospects__row__box__content">
            <p class="prospects__row__box__content__title">Desembolso de interesados</p>
            <div class="prospects__row__box__content__text">
              <p class="prospects__row__box__content__text__before">Se han desembolsado</p>
              <p class="prospects__row__box__content__text__after">{{ payedUsers }} de {{ alreadyUsers.length }} interesados</p>
            </div>
          </div>
          <div class="prospects__row__box__circle">
            <vue-easy-pie-chart
              :bar-color="'#bfcd32'"
              :font-size="'15px'"
              :track-color="'#f2f2f2'"
              :scale-color="''"
              :percent="alreadyUsers.length ? Math.round(payedUsers * 1000 / alreadyUsers.length) / 10 : 0"
              :size="70"
              :line-cap="'round'"
              :line-width="4"
            >
            </vue-easy-pie-chart>
          </div>
        </div>
      </div>

      <div class="prospects__row prospects__row--center prospects__row--top-margin" v-show="!alreadyUsers.length && alreadyusersFirstLoad.status && !alreadyusersFirstLoad.length">
        <div class="prospects__row__box--alone prospects__white-row">
          <div class="prospects__row__box__content prospects__row__box__content--text-center">
            Muy pronto nos comunicaremos contigo para confirmarte el número exacto de prospectos al que se enviará el mensaje
          </div>
        </div>
      </div>

      <Totals></Totals>

      <div v-show="isFilterActive" class="prospects__row prospects__white-row prospects__row--filters">
        <ActiveFilter></ActiveFilter>
      </div>

      <Table v-show="alreadyusersFirstLoad.status && alreadyusersFirstLoad.length"></Table>
    </Layout>
  </div>
</template>

<script>
// @ is an alias to /src
import Layout from '@/components/Layout'
import Totals from '@/components/Totals'
import Table from '@/components/Table'
import ActiveFilter from '../components/ActiveFilter'
import VueEasyPieChart from 'vue-easy-pie-chart'
import 'vue-easy-pie-chart/dist/vue-easy-pie-chart.css'

let timeout

export default {
  name: 'Home',
  components: {
    Layout,
    Totals,
    Table,
    ActiveFilter,
    VueEasyPieChart
  },
  data () {
    return {
      topFilter: {
        show: false,
        general: false
      },
      batches: [],
      alreadyUsersFirstLoadLocal: false
    }
  },
  computed: {
    alreadyUsers () {
      return this.$store.getters.leads.users.already
    },
    payedUsers () {
      return this.alreadyUsers.filter(el => el.status === 'payed').length
    },
    isFilterActive () {
      return this.$store.getters.isFilterActive
    },
    filter () {
      const { version, sector, kindOfPerson } = this.$store.getters.aqlFilter
      const { opts: { time: months } } = this.$store.getters.filter

      return {
        ubication: version ? `${version[0]} (${version.length})` : '-',
        sector: sector ? sector.length : '-',
        person: kindOfPerson ? kindOfPerson[0] === 1 ? 'Juridica' : 'Natural' : '-',
        months: months.show ? months.key : '-'
      }
    },
    batchesPurchase () {
      return this.$store.getters.batchesPurchase
    },
    alreadyusersFirstLoad () {
      return this.$store.getters.alreadyusersFirstLoad
    },
    totalsProspects () {
      const totals = this.batchesPurchase.map(batch => batch.total)
      return totals.length ? totals.reduce((accum, total) => accum + total) : 0
    },
    waitingResponseUsers () {
      const waiting = this.totalsProspects - this.alreadyUsers.length
      return waiting < 0 ? 0 : waiting
    }
  },
  watch: {
    batchesPurchase: {
      deep: true,
      handler: function (value) {
        this.batches = value
        const prospectsFilter = this.$store.getters.prospectsFilter
        this.topFilter.general = false

        const localBatchesPurchase = []
        for (const batch of this.batches) {
          if (batch.isConsidered) {
            localBatchesPurchase.push(String(batch.idLocal))
          }
        }

        const actualBatches = JSON.stringify(localBatchesPurchase)
        const previousBatches = JSON.stringify(prospectsFilter.localBatchesPurchase)

        const isThereNewBatches = !Object.is(actualBatches, previousBatches)

        if (timeout) {
          clearTimeout(timeout)
        }

        if (isThereNewBatches && this.alreadyUsersFirstLoadLocal) {
          timeout = setTimeout(() => {
            this.$store.commit('prospectsFilter', { ...prospectsFilter, localBatchesPurchase })
            this.$store.dispatch('alreadyUsers')
          }, 1100)
        } else {
          this.alreadyUsersFirstLoadLocal = true
        }
      }
    }
  },
  methods: {
    toggleTopFilter () {
      this.topFilter.show = !this.topFilter.show
    },
    generalBatches () {
      const batches = [...this.batchesPurchase]
      const prospectsFilter = this.$store.getters.prospectsFilter

      const localBatchesPurchase = []
      for (const batch of batches) {
        batch.isConsidered = true
        localBatchesPurchase.push(String(batch.idLocal))
      }

      const actualBatches = JSON.stringify(localBatchesPurchase)
      const previousBatches = JSON.stringify(prospectsFilter.localBatchesPurchase)

      const isThereNewBatches = !Object.is(actualBatches, previousBatches)

      if (isThereNewBatches) {
        this.$store.commit('prospectsFilter', { ...prospectsFilter, localBatchesPurchase })
        this.$store.dispatch('alreadyUsers')
      }

      this.batches = batches
    }
  },
  mounted () {
    this.batches = this.batchesPurchase
  },
  destroyed () {
    // reset alreadyUsers
    this.$store.commit('prospectsFilter', { localBatchesPurchase: [], name: '', statuses: [] })
    this.$store.dispatch('alreadyUsers')
  }
}
</script>

<style>
.prospects__row {
  margin: 5px 0;
  width: 100%;
}

.prospects__row--center {
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.prospects__row--top-margin {
  margin-top: 20px;
}

.prospects__row--to-left {
  font-size: 12px;
  font-weight: 100;

  align-items: flex-start;
  background-color: #ffffff;
  border: 1px solid #ffffff;
  border-radius: 10px;
  box-shadow: 0px 0px 5px rgba(0,0,0,0.1);
  display: flex;
  flex-direction: column;
  justify-content: left;
  padding: 5px 12px 5px 5px;
}

.prospects__row__top-filter {
  float: right;
  position: absolute;
  top: 195px;
  z-index: 1;
}

.prospects__row__top-filter--to-left {
  font-size: 12px;
  font-weight: 100;

  align-items: flex-start;
  background-color: #ffffff;
  border: 1px solid #ffffff;
  border-radius: 10px;
  box-shadow: 0px 0px 5px rgba(0,0,0,0.1);
  display: flex;
  flex-direction: column;
  height: 150px;
  justify-content: left;
  overflow: auto;
  padding: 5px 12px 5px 5px;
}

.prospects__row__button-container {
  float: right;
}

.prospects__white-row {
  background-color: #ffffff;
  border: 1px solid #ffffff;
  border-radius: 4px;
  box-shadow: 1px 2px 5px rgba(0, 0, 0, 0.1);
}

.prospects__white-row--no-interested-users {
  color: #00535e;
  font-weight: 600;

  align-items: center;
  background-color: #ffffff;
  border: 1px solid #ffffff;
  border-radius: 4px;
  box-shadow: 0px 0px 5px rgba(0,0,0,0.1);
  display: flex;
  height: 30px;
  justify-content: center;
  padding: 20px 30px;
  width: 100%;
}

.prospects__row__box {
  align-items: center;
  display: flex;
  height: 130px;
  justify-content: space-between;
  padding: 20px 30px;
  width: calc(50% - 15px);
}

.prospects__row__box--alone {
  align-items: center;
  display: flex;
  height: 130px;
  justify-content: space-between;
  padding: 20px 30px;
  width: 100%;
}

.prospects__row__box__content__title {
  color: #595959;
  font-size: 16px;
  font-weight: 100;
  text-align: left;
}

.prospects__row__box__content__text {
  display: flex;
  flex-direction: row;
  margin-top: 5px;
}

.prospects__row__box__content__text__before {
  color: #808080;
  font-size: 12px;
  font-weight: 100;

  padding-right: 10px;
}

.prospects__row__box__content__text__after {
  color: #595959;
  font-size: 13px;
  font-weight: bold;
}

.prospects__row__box__content__text__after--minor {
  color: #595959;
  font-size: 11px;
  font-weight: bold;
}

.prospects__row__box__content--text-center {
  text-align: center;
  width: 100%;
}

.prospects__row--flex-column {
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.prospects__row--flex-row {
  align-items: center;
  background-color: #f7f7f7;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 20px;
  margin-top: 0px;
}

.prospects__row__search-filter {
  align-items: flex-start;
  display: flex;
  flex-direction: row;
  height: 64px;
  justify-content: space-around;
  margin-bottom: 20px;
  padding: 15px 30px;
  width: calc(50% - 15px);
}

.prospects__row__search-filter__container {
  width: 200px;
}

.prospects__row__search-filter__input-box {
  height: 25px;
  width: 150px;
}

.prospects__row__search-filter__button-container {
  color: #999999;
  font-size: 12px;
  font-weight: 500;
  line-height: 25px;
  text-align: left;
  text-decoration: none;

  background: #fff;
  border: 1px solid #ccc;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  height: 25px;
  justify-content: space-between;
  margin: 5px auto;
  padding-left: 7px;
  transition: .2s;
  vertical-align: middle;
  width: 150px;
}

.prospects__row__search-filter__button-container:hover {
  background: #ebebeb;
  border: 1px solid #b3b3b3;
}

.prospects__row__search-filter__table-filter {
  float: left;
  position: relative;
  width: 150px;
}

.prospects__row__search-filter__table-filter--to-left {
  font-size: 12px;
  font-weight: 100;

  align-items: flex-start;
  background-color: #ffffff;
  border: 1px solid #ffffff;
  border-radius: 10px;
  box-shadow: 0px 0px 5px rgba(0,0,0,0.1);
  display: flex;
  flex-direction: column;
  justify-content: left;
  padding: 5px 12px 5px 5px;
}

.prospects__row__search-filter__by-name {
  color: #898989;
  font-size: 12px;

  border: 1px solid #bcbcbc;
  border-radius: 5px;
  height: 22px;
  padding-left: 7px;
  width: 120px;
}

.prospects__row--filters {
  align-items: center;
  display: flex;
  flex-direction: row;
  height: 100px;
  justify-content: space-around;
  margin-bottom: 20px;
}

.prospects__row__filter {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.prospects__row__filter__header {
  color: #00535e;
  font-size: 13px;
  font-weight: 100;
  text-align: center;

  width: fit-content;
}

.prospects__row__filter__body {
  color: #00535e;
  font-size: 13px;
  font-weight: bold;
  text-align: center;

  border-color: #cccccc;
  border-radius: 20px;
  border-style: solid;
  border-width: 1px;
  width: 140px;
}

.prospects__row__box__circle {
  width: fit-content;
}
</style>
